import reducer from './reducers'
export { default as operations } from './operations'
export { default as types } from './types'

export default reducer
